import { QrScanner } from "@yudiel/react-qr-scanner";
import React, { Fragment, useState } from "react";
import { createChatSocket } from "../../utils/chatSocket";
import axios from "axios";
import Snackbar from "../../UI/Snackbar";
import RefreshIcon from "@mui/icons-material/Refresh";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Typography } from "@mui/material";
//import PopoverBtns from "./StateChgPopover"

///////////// socket.io //////////////
const socket = createChatSocket();
///////////// socket.io //////////////

const scanbtn = {
  width: "45%",
  marginTop: "10px",
  padding: "10px",
  height: "50px",
  backgroundColor: "#000000",
  color: "#ffffff",
  fontSize: "1.5rem",
  fontWeight: "bold",
  border: "none",
  borderRadius: "10px",
  cursor: "pointer",
};

const closebtn = {
  width: "45%",
  marginTop: "10px",
  padding: "10px",
  height: "50px",
  backgroundColor: "#f44336",
  color: "#ffffff",
  fontSize: "1.5rem",
  fontWeight: "bold",
  border: "none",
  borderRadius: "10px",
  cursor: "pointer",
};

const buttonContainer = {
  display: "flex",
  justifyContent: "space-around",
  alignItems: "center",
  width: "calc(100% - 40px)",
  maxWidth: "calc(100% - 40px)",
  margin: "10px auto",
  padding: "0 20px",
  boxSizing: "border-box",
};

const resulttxt = {
  width: "calc(100% - 40px)",
  maxWidth: "calc(100% - 40px)",
  padding: "12px",
  minHeight: "50px",
  backgroundColor: "#ffffff",
  color: "#000000",
  fontSize: "1.4rem",
  fontWeight: "bold",
  margin: "20px auto 10px auto",
  border: "1px solid #000000",
  borderRadius: "10px",
  cursor: "pointer",
  textAlign: "center",
  boxSizing: "border-box",
};

// TS 버튼 스타일
const tsButtonStyle = {
  padding: "5px 10px",
  backgroundColor: "#ff9800",
  color: "white",
  border: "none",
  borderRadius: "5px",
  marginLeft: "10px",
  cursor: "pointer",
  fontSize: "0.9rem",
  fontWeight: "bold",
};

// 모달 스타일
const modalStyle = {
  position: "fixed",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  backgroundColor: "white",
  padding: "20px",
  borderRadius: "10px",
  boxShadow: "0 0 10px rgba(0,0,0,0.2)",
  zIndex: 1000,
  width: "90%",
  maxWidth: "400px",
};

const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "rgba(0,0,0,0.5)",
  zIndex: 999,
};

const inputStyle = {
  width: "100%",
  padding: "10px",
  marginBottom: "10px",
  border: "1px solid #ccc",
  borderRadius: "5px",
};

const buttonGroupStyle = {
  display: "flex",
  justifyContent: "space-between",
  marginTop: "15px",
};

// 대기중 ? 0
// 이동중 ? 1
// 활동중 ? 2
// 원복귀 ? 3
const Qrcodereader = (props) => {
  const { mfdata, qrButtonClicked, qrMode, title = "QR 코드 스캐너" } = props; // qrMode: "stateOnly" 상단=상태변경만, "registerOnly" 자원별=QR등록만
  const [result, setResult] = useState(); // 스캔결과
  const [scanox, setScanox] = useState(false); // 스캔여부
  const [showModal, setShowModal] = useState(false); // 모달 표시 여부
  const [dummyData, setDummyData] = useState("1234^5678^서울 펌프1^대기중"); // 더미 데이터
  const [showStateButtons, setShowStateButtons] = useState(false);
  const [scannedData, setScannedData] = useState(null);
  const [qrBTNclicked, setQrBTNclicked] = useState(qrButtonClicked);

  ///////////// socket.io //////////////
  // useEffect(() => {
  //   console.log("socket.on useEffect")
  //   socket.on("stsync", (data) => {  // 소켓서버에서 보낸 자료를 받음
  //     const { name, msg, time } = data;
  //     console.log(+new Date()+" : "+name+" : "+msg+" : "+time);
  //     // const { name, msg, time } = data;
  //     // const item = new LiModel(name, msg, time);
  //     // item.makeLi();
  //     alert(+new Date()+" : "+name+" : "+msg+" : "+time );
  //   });
  // }, []);

  const sendsync = (sort, org, eqp, csgn, extra = {}) => {
    // 소캣서버로 갱신변경 자료를 보냄
    // yy-dd-mm hh:mm:ss 값으로 변환
    const nowdt = new Date();
    const yy = nowdt.getFullYear();
    const mm = nowdt.getMonth() + 1;
    const dd = nowdt.getDate();
    const hh = nowdt.getHours();
    const mi = nowdt.getMinutes();
    const nowdtstr = `${yy}.${mm}.${dd} ${hh}:${mi}`;
    const param = {
      sort: sort,
      inputuser: sessionStorage.mfmid,
      dsid: sessionStorage.selectedDSid.trim(),
      org: org, // 기관 서울,경기 등
      eqp: eqp, // 장비 종류
      csgn: csgn, // 장비명
      seqnum: extra.seqnum,
      mfstatus: extra.mfstatus,
      transtxt: `${nowdtstr} ${org} ${csgn.trim()} ${
        sessionStorage.selectedFromState
      } -> ${sessionStorage.selectedToState} 변경`,
    };
    console.log(param);
    socket.emit("stsync", param);
  };
  ///////////// socket.io //////////////

  // 테스트 버튼 클릭 핸들러
  const handleTestButtonClick = () => {
    setShowModal(true);
  };

  // 더미 데이터 입력 핸들러
  const handleDummyDataChange = (e) => {
    setDummyData(e.target.value);
  };

  // 더미 데이터 제출 핸들러
  const handleSubmitDummyData = () => {
    setShowModal(false);
    processQRData(dummyData);
  };

  // 모달 닫기 핸들러
  const handleCloseModal = () => {
    setShowModal(false);
  };

  // QR 스캔데이터가 QR등록이거나 전용등록큐알이용 상태변경이면 처리 ===============================
  const inputQRcode = async (data) => {
    console.log("inputQRcode 함수 실행:", data);

    // 스캔 상태 업데이트
    setScanox(true);

    // mflist에서 QR코드 확인
    const mflist = JSON.parse(sessionStorage.mflist || "[]");
    const matchingItem = mflist.find((item) => item.mfqcode === data);
    
    // 관리 버튼의 QR 등록인 경우 (qrButtonClicked === true)
    if (matchingItem && qrButtonClicked) {
      // 이미 등록된 QR 코드가 다른 자원에 등록되어 있는 경우
      const qrsnum = sessionStorage.snumforqrinput;
      const itemSnum = typeof matchingItem.snum === "string" ? matchingItem.snum : String(matchingItem.snum);
      const qrSnum = typeof qrsnum === "string" ? qrsnum : String(qrsnum);
      
      // 현재 등록하려는 자원과 다른 자원에 등록되어 있는 경우
      if (itemSnum !== qrSnum) {
        const orgName = matchingItem.mfdorg.replace(
          /본부|소방|안전|구조|재난|상|라|청|도|입력/g,
          ""
        );
        const eqpName = matchingItem.mfeqp.replace("소방", "");
        const errorMessage = `${orgName} ${eqpName} ${matchingItem.mfcsgn}에 등록되어 있어 이중등록이 불가합니다.`;
        callSnakbar(errorMessage, "error");
        setResult(errorMessage);
        setScanox(false); // 스캔 재시도 가능하도록
        return;
      }
    }
    
    // 상단 QR (stateOnly): 등록된 QR만 인식 → 상태변경만 가능
    const isStateOnly = qrMode === "stateOnly" || !qrButtonClicked;
    if (matchingItem && isStateOnly) {
      let seqnum, dsid, orgg, eqpp, stat;
      seqnum = matchingItem.seqnum;
      dsid = matchingItem.dsnum;
      orgg = matchingItem.mfdorg.replace(
        /본부|소방|안전|구조|재난|상|라|청|도|입력/g,
        ""
      );
      eqpp = matchingItem.mfeqp.replace("소방", "");
      // mfstatus 값을 이동,활동,대기,집결로 환산
      // mfstatus가 없거나 undefined인 경우 기본값 설정
      const mfstatus = matchingItem.mfstatus !== undefined && matchingItem.mfstatus !== null 
        ? matchingItem.mfstatus 
        : 0; // 기본값: 대기중
      
      switch (mfstatus) {
        case 0:
          stat = "대기중";
          break;
        case 1:
          stat = "이동중";
          break;
        case 2:
          stat = "활동중";
          break;
        case 3:
          stat = "복귀중";
          break;
        case 9:
          stat = "집결중";
          break;
        default:
          stat = "대기중"; // 기본값
          break;
      }

      const formattedData = `${seqnum}^${dsid}^${orgg} ${eqpp}^${stat}`;
      console.log("Formatted QR data:", formattedData);
      //갱신정보 자료 송신
      handleScan(formattedData);
      return;
    }

    // 상단 QR에서 미등록 QR 스캔 시: 등록하지 않고 안내만
    if (isStateOnly) {
      callSnakbar("등록된 QR이 아닙니다. 상태변경은 이미 등록된 QR만 스캔해 주세요.", "error");
      setResult("등록된 QR이 아닙니다. 상태변경은 등록된 QR만 가능합니다.");
      setScanox(false);
      return;
    }

    // 자원별 QR (registerOnly): 해당 자원에 QR 등록만
    const qrsnum = sessionStorage.snumforqrinput;
    if (!qrsnum) {
      callSnakbar("등록 대상 자원이 지정되지 않았습니다.", "error");
      setScanox(false);
      return;
    }
    const wstring = `${props.apiAddr}/get/inputqr?snum=${qrsnum}&qrcode=${data}`;
    console.log("API 호출 URL:", wstring);

    try {
      const response = await axios.get(wstring);
      const result = response.data.result;
      if (result == "success") {
        console.log("input success");
        callSnakbar("QR 등록에 성공했습니다.", "success");
        setResult("QR 등록에 성공했습니다.");
        
        // mflist에서 해당 snum을 가진 항목을 찾아 mfqcode 업데이트
        const mflist = JSON.parse(sessionStorage.mflist || "[]");
        const updatedMflist = mflist.map((item) => {
          // item.snum을 문자열로 변환하여 비교
          const itemSnum = typeof item.snum === "string" ? item.snum : String(item.snum);
          const qrSnum = typeof qrsnum === "string" ? qrsnum : String(qrsnum);
          
          if (itemSnum === qrSnum) {
            console.log("QR 코드 업데이트:", item.snum);
            return { ...item, mfqcode: data };
          }
          return item;
        });
        sessionStorage.setItem("mflist", JSON.stringify(updatedMflist));
        
        // QR 등록 성공 콜백 호출
        if (props.onQRRegistered) {
          props.onQRRegistered(updatedMflist);
        }
      } else {
        console.log("input fail");
        callSnakbar("QR 등록에 실패했습니다.", "error");
        setResult("QR 등록에 실패했습니다.");
      }
    } catch (error) {
      console.error("QR 등록 중 오류 발생:", error);
      callSnakbar("QR 등록 중 오류가 발생했습니다.", "error");
      setResult("QR 등록 중 오류가 발생했습니다.");
    }

    console.log("step3 regist complete");
  };

  // QR 스캔 데이터 처리 라우터 함수=============================================================
  const processQRData = (data) => {
    console.log("step1 successed QR reading!");
    if (!data) return;
    setScanox(false);
    // QR 코드 데이터의 "^" 문자 갯수 확인(상태변경 큐알 인식이면)
    const caretCount = (data.match(/\^/g) || []).length;
    if (caretCount >= 3) {
      console.log("step2 changed state!");
      //상태 변경 호출
      handleScan(data);
    } else {
      //신규 큐알 등록 호출
      console.log("step2 New QR regist for each!");
      inputQRcode(data);
    }
  };

  // qr 스캔이 상태변경이면 ================================================================
  let arr, seqnum, dsid, org, csgn, eqp, state, status;
  const handleScan = (data) => {
    // QR 코드 데이터의 "^" 문자 갯수 확인
    const caretCount = (data.match(/\^/g) || []).length;
    if (caretCount < 3) {
      callSnakbar("잘못된 QㄲR 코드 형식입니다.", "error");
      return;
    }

    // qr스캔시 성공시
    if (data) {
      console.log(data);
      // setResult(data);
      arr = data.split("^");
      seqnum = arr[0];
      dsid = arr[1];
      const orgCsgn = arr[2] || ""; // arr[2]가 없을 경우 빈 문자열
      const orgCsgnParts = orgCsgn.split(" ");
      org = orgCsgnParts[0] || "";
      csgn = orgCsgnParts[1] || "";

      if (csgn.indexOf("펌프") > -1) {
        // 펌프일때
        eqp = "펌프";
      } else if (csgn.indexOf("탱크") > -1) {
        // 발전기일때
        eqp = "물탱크";
      } else if (csgn.indexOf("화학") > -1) {
        // 발전기일때
        eqp = "화학";
      } else if (csgn.indexOf("험지") > -1) {
        // 발전기일때
        eqp = "험지";
      } else if (csgn.indexOf("구조") > -1) {
        // 발전기일때
        eqp = "구조";
      } else if (csgn.indexOf("구급") > -1) {
        // 발전기일때
        eqp = "구급";
      } else if (csgn.indexOf("헬기") > -1) {
        // 발전기일때
        eqp = "헬기";
      } else if (csgn.indexOf("지휘") > -1) {
        // 발전기일때
        eqp = "지휘";
      } else if (csgn.indexOf("행정") > -1) {
        // 행정일때
        eqp = "행정";
      } else if (csgn.indexOf("회복") > -1) {
        // 회복일때
        eqp = "회복";
      } else if (csgn.indexOf("위성") > -1) {
        // 위성일때
        eqp = "위성";
      } else {
        eqp = "";
      }

      state = arr[3] || "대기중"; // state가 없을 경우 기본값 설정

      // 스캔된 데이터 저장하고 상태 버튼 표시
      setScannedData({
        seqnum,
        dsid,
        org,
        eqp,
        csgn,
        currentState: state,
      });

      setResult(`${org} ${csgn} (현재: ${state})`);
      setShowStateButtons(true);
      setScanox(true);
    }
  };

  // 상태 버튼 클릭 시 호출되는 함수
  const handleStateButtonClick = (newState, statusCode) => {
    if (scannedData) {
      const { seqnum, dsid, org, eqp, csgn, currentState } = scannedData;

      // SessionStorage 설정
      sessionStorage.selectedFromState = currentState;
      sessionStorage.selectedToState = newState;

      // 상태 변경 호출
      sendStateChagedData(
        seqnum,
        dsid,
        org,
        eqp,
        csgn,
        currentState,
        statusCode
      );
      setShowStateButtons(false);
    }
  };

  // 상태 변경 취소 버튼 클릭 시 호출되는 함수
  const handleCancelStateChange = () => {
    setShowStateButtons(false);
    setResult("상태 변경이 취소되었습니다.");
  };

  const handleError = (err) => {
    // 에러 로깅
    console.error("QR 스캔 에러:", err);

    // Event 객체가 전달된 경우 처리
    if (err && typeof err === 'object' && !err.name && !err.message) {
      // Event 객체인 경우 무시하거나 기본 메시지 표시
      console.warn("Event 객체가 전달되었습니다. 무시합니다.");
      return;
    }

    // 에러 유형에 따른 메시지 설정
    let errorMessage = "QR 코드 스캔 중 오류가 발생했습니다.";

    // err가 유효한 에러 객체인지 확인
    if (err && err.name) {
      if (err.name === "NotFoundError" || err.name === "DevicesNotFoundError") {
        errorMessage =
          "카메라를 찾을 수 없습니다. 카메라가 연결되어 있는지 확인해주세요.";
      } else if (
        err.name === "NotAllowedError" ||
        err.name === "PermissionDeniedError"
      ) {
        errorMessage =
          "카메라 접근 권한이 거부되었습니다. 브라우저 설정에서 카메라 접근을 허용해주세요.";
      } else if (
        err.name === "NotReadableError" ||
        err.name === "TrackStartError"
      ) {
        errorMessage =
          "카메라에 접근할 수 없습니다. 다른 앱에서 카메라를 사용 중인지 확인해주세요.";
      } else if (err.name === "OverconstrainedError") {
        errorMessage = "요청한 카메라 설정을 만족하는 장치가 없습니다.";
      } else if (err.message && err.message.includes("getUserMedia")) {
        errorMessage =
          "카메라 접근 API가 지원되지 않습니다. HTTPS 환경에서 실행하거나 최신 브라우저를 사용해주세요.";
      }
    }

    // 스낵바로 에러 메시지 표시
    callSnakbar(errorMessage, "error");

    // 결과 화면에 에러 표시
    setResult("에러: " + errorMessage);

    // 스캔 상태 업데이트
    setScanox(true);
  };

  const scanHandler = () => {
    // 재스캔 버튼 클릭시
    console.log(scanox);
    console.log(qrBTNclicked);
    setScanox(!scanox);
    setResult("");
    setQrBTNclicked(false);
  };

  // 종료 버튼 핸들러
  const handleClose = () => {
    // 부모 컴포넌트에서 QR 스캐너를 닫는 함수 호출
    if (props.onClose) {
      props.onClose();
    }
    setQrBTNclicked(false);
  };

  async function sendStateChagedData(
    seqnum,
    dsid,
    org,
    eqp,
    csgn,
    state,
    status
  ) {
    // 상태변경 DB입력
    const wstring = `${props.apiAddr}/get/sendStateChagedDatafromQr?dsid=${dsid}&seqnum=${seqnum}&status=${status}`;
    console.log(wstring);
    const response = await axios.get(wstring);
    const result = response.data.result;
    if (result == "success") {
      // alert("등록되었습니다.");
      callSnakbar("수정되었습니다.", "success");
      if (typeof window.dispatchEvent === "function") {
        window.dispatchEvent(new CustomEvent("mfHistoryRefresh"));
      }
      setTimeout(() => {
        sendsync("stateChaged", org, eqp, csgn, { seqnum, mfstatus: status });
      }, 100);

      let txt = `${org} ${csgn.trim()} ${sessionStorage.selectedFromState} -> ${
        sessionStorage.selectedToState
      } 변경`;
      let secondSpaceIndex = txt.indexOf(" ", txt.indexOf(" ") + 1);
      // 두 번째 공백을 찾았다면, 그 위치에서 줄바꿈으로 대체합니다.
      if (secondSpaceIndex !== -1) {
        txt =
          txt.substring(0, secondSpaceIndex) +
          "\n" +
          txt.substring(secondSpaceIndex + 1);
      }
      setResult(txt);

      // seqnum을 문자열로 변환
      const strSeqnum = String(seqnum);

      // mflist에서 해당 dsnum와 seqnum을 가진 항목을 찾아 status 업데이트
      const mflist = JSON.parse(sessionStorage.mflist || "[]");
      console.log("갱신중");
      const updatedMflist = mflist.map((item) => {
        // item.seqnum을 문자열로 변환하여 비교
        const itemSeqnum = String(item.seqnum);
        if (item.dsnum === dsid && itemSeqnum === strSeqnum) {
          console.log("같은거 찾음");
          return { ...item, mfstatus: status };
        }
        return item;
      });
      sessionStorage.setItem("mflist", JSON.stringify(updatedMflist));
      
      // 상태 변경 성공 콜백 호출 (부모 컴포넌트의 리스트 갱신을 위해)
      if (props.onStateChanged) {
        props.onStateChanged(updatedMflist);
      }
    } else {
      // alert("등록에 실패하였습니다.");
      callSnakbar("수정에 실패했습니다.", "error");
    }
  }

  //////////////  스낵바 호출 //////////////
  const [sbShow, setSbShow] = useState("");
  const callSnakbar = (msg, sort) => {
    // const msg = "삭제되었습니sdfsdfsd다.";
    // const sort = "warning" // info, success, warning, error
    setSbShow(+new Date() + "^" + msg + "^" + sort);
  };
  //////////////  스낵바 호출 //////////////

  return (
    <Fragment>
      <Snackbar sbShow={sbShow} />

      <Box
        sx={{
          padding: "20px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "15px",
            width: "100%",
          }}
        >
          <Typography
            variant="h5"
            sx={{
              fontWeight: "bold",
              fontSize: "1.3rem",
            }}
          >
            {title}
          </Typography>
        </Box>

        <Box
          sx={{
            width: "calc(100% - 40px)",
            maxWidth: "500px",
            margin: "0 auto 15px auto",
            boxSizing: "border-box",
          }}
        >
          <QrScanner
            onDecode={processQRData}
            onError={handleError}
            stopDecoding={scanox}
          />
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-around",
            alignItems: "center",
            width: "calc(100% - 40px)",
            maxWidth: "calc(100% - 40px)",
            margin: "10px auto",
            padding: "0 20px",
            boxSizing: "border-box",
          }}
        >
          <button
            style={scanbtn}
            onClick={() => {
              scanHandler();
            }}
          >
            <RefreshIcon style={{ fontSize: "1.8rem" }} />
          </button>
          <button style={closebtn} onClick={handleClose}>
            <CloseIcon style={{ fontSize: "1.8rem" }} />
          </button>
        </Box>

        <Box sx={resulttxt}>
          {result && <Typography sx={{ fontSize: "1.2rem", wordBreak: "break-word" }}>{result}</Typography>}
          {qrBTNclicked && (
            <Box sx={{ marginTop: "8px" }}>
              <Typography sx={{ fontSize: "1rem", marginBottom: "4px" }}>
                소속: {mfdata?.mfdorg || "N/A"}
              </Typography>
              <Typography sx={{ fontSize: "1rem" }}>
                장비명: {mfdata?.mfeqp || "N/A"}
              </Typography>
            </Box>
          )}
        </Box>

        {/* 상태 변경 버튼들 추가 */}
        {showStateButtons && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "10px",
              marginTop: "10px",
              width: "calc(100% - 40px)",
              maxWidth: "calc(100% - 40px)",
              padding: "0 20px",
              boxSizing: "border-box",
            }}
          >
            <Typography
              sx={{
                fontSize: "1.2rem",
                fontWeight: "bold",
                marginBottom: "5px",
              }}
            >
              상태 변경:
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                gap: "10px",
                marginBottom: "10px",
                width: "100%",
              }}
            >
            {scannedData?.currentState !== "대기중" && (
              <button
                style={{
                  padding: "12px 20px",
                  backgroundColor: "#4CAF50",
                  color: "white",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                  fontWeight: "bold",
                  minWidth: "100px",
                  fontSize: "1.1rem",
                }}
                onClick={() => handleStateButtonClick("대기중", 0)}
              >
                대기중
              </button>
            )}
            {scannedData?.currentState !== "이동중" && (
              <button
                style={{
                  padding: "12px 20px",
                  backgroundColor: "blue",
                  color: "white",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                  fontWeight: "bold",
                  minWidth: "100px",
                  fontSize: "1.1rem",
                }}
                onClick={() => handleStateButtonClick("이동중", 1)}
              >
                이동중
              </button>
            )}
            {scannedData?.currentState !== "활동중" && (
              <button
                style={{
                  padding: "12px 20px",
                  backgroundColor: "red",
                  color: "white",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                  fontWeight: "bold",
                  minWidth: "100px",
                  fontSize: "1.1rem",
                }}
                onClick={() => handleStateButtonClick("활동중", 2)}
              >
                활동중
              </button>
            )}
            </Box>
            <button
              style={{
                padding: "8px 15px",
                backgroundColor: "darkgrey",
                color: "black",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
                fontWeight: "bold",
              }}
              onClick={handleCancelStateChange}
            >
              취소
            </button>
          </Box>
        )}
      </Box>

      {/* 더미 데이터 입력 모달 */}
      {showModal && (
        <>
          <div style={overlayStyle} onClick={handleCloseModal}></div>
          <div style={modalStyle}>
            <h3>테스트 데이터 입력</h3>
            <p style={{ fontSize: "0.9rem", marginBottom: "15px" }}>
              형식: 일련번호^재난ID^기관 장비명^상태
              <br />
              예시: 1234^5678^서울 펌프1^대기중
            </p>
            <input
              type="text"
              value={dummyData}
              onChange={handleDummyDataChange}
              style={inputStyle}
              placeholder="더미 데이터 입력"
            />
            <div style={buttonGroupStyle}>
              <button
                onClick={handleCloseModal}
                style={{ ...tsButtonStyle, backgroundColor: "#999" }}
              >
                취소
              </button>
              <button
                onClick={handleSubmitDummyData}
                style={{ ...tsButtonStyle, backgroundColor: "#4CAF50" }}
              >
                테스트 실행
              </button>
            </div>
          </div>
        </>
      )}
    </Fragment>
  );
};

export default Qrcodereader;
